import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Typography } from '@/ui/atoms/typography/Typography'

interface TokenListItemProps {
  token: Token
  value: NormalizedUnitNumber
  isL1?: boolean
}

export function TokenListItem({ token, value, isL1 }: TokenListItemProps) {
  return (
    <div className="flex items-center justify-between py-3">
      <div className="flex items-center gap-3">
        <div className="relative">
          <TokenIcon token={token} className="w-10" />
          {isL1 && (
            <div className="-bottom-1 -right-1 absolute flex h-5 w-5 items-center justify-center rounded-[6px] border border-black bg-primary-bg font-bold text-black text-xs">
              L1
            </div>
          )}
        </div>
        <div>
          <Typography variant="p">{token.name}</Typography>
          <Typography variant="p" className="text-sm text-white/50">
            {token.format(value, { style: 'compact' })} {token.symbol}
          </Typography>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {token.unitPriceUsd.eq(0) ? (
          <Typography variant="prompt">-</Typography>
        ) : (
          <Typography variant="p">{token.formatUSD(value)}</Typography>
        )}
      </div>
    </div>
  )
}
